// telemetry.js — instrumentation légère client (Sprint 1)

const KEY = 'pros_telemetry_v1';
const MAX = 120;

function _load() {
  try { return JSON.parse(sessionStorage.getItem(KEY) || '[]'); } catch { return []; }
}

function _save(rows) {
  try { sessionStorage.setItem(KEY, JSON.stringify(rows.slice(-MAX))); } catch {}
}

export function trackMetric(type, payload = {}) {
  const rows = _load();
  rows.push({ type, ts: Date.now(), ...payload });
  _save(rows);
}

export function initTelemetry() {
  window.addEventListener('error', e => {
    trackMetric('js_error', { msg: e.message || 'error' });
  });

  window.addEventListener('unhandledrejection', e => {
    trackMetric('promise_rejection', { msg: String(e.reason || 'rejection') });
  });

  const obs = new PerformanceObserver((list) => {
    for (const entry of list.getEntries()) {
      if (entry.entryType === 'paint') {
        trackMetric('paint', { name: entry.name, ms: Math.round(entry.startTime) });
      }
      if (entry.entryType === 'largest-contentful-paint') {
        trackMetric('lcp', { ms: Math.round(entry.startTime) });
      }
    }
  });

  try { obs.observe({ type: 'paint', buffered: true }); } catch {}
  try { obs.observe({ type: 'largest-contentful-paint', buffered: true }); } catch {}
}
